module.exports = {
    "E01" : "Unable to process the request, try again later",
    "E02" : "Unable to process the request, try again later",
    "E03" : "Unable to process the request, try again later",
    };
